export default {
  "HitPaw Add Music to Audio Online": "HitPaw 온라인 오디오에 음악 추가기",
  "Add BGM to Audio without any difficulties.": "문제 없이 오디오에 BGM을 추가합니다.",
  "Add New": "새로 추가",
  "Format": "형식",
  "Add tracks": "트랙 추가",

};
